var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHCcvDjwv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1342_6088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3333 23.7993V18.7071C36.3333 18.1693 35.7998 17.7333 35.1424 17.7333C27.4157 17.7333 21.6207 17.7333 17.7574 17.7333C17.3795 17.7333 16.8127 17.7333 16.057 17.7333C15.3996 17.7333 14.8667 18.1693 14.8667 18.7071V36.3596C14.8667 36.8974 15.3996 37.3333 16.057 37.3333H35.1424C35.7998 37.3333 36.3333 36.8974 36.3333 36.3596V31.2673V23.7993Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8706 31.2673L43.0612 34.526C43.3977 34.7032 43.8 34.456 43.8 34.0717V20.9944C43.8 20.6111 43.3977 20.3635 43.0612 20.5406L36.8706 23.7993",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1342_6088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHCcvDjwv);
export default __webpack_public_path__ + "static/media/hCCVDjwv.2ab2eaafd13c623dda25292b2193fd26.svg";
export { ForwardRef as ReactComponent };